import { render, staticRenderFns } from "./SoundLibrary.vue?vue&type=template&id=54420a16&"
import script from "./SoundLibrary.vue?vue&type=script&lang=js&"
export * from "./SoundLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports